import { DuplicateObject, UploadError } from '../models';
import { t } from 'i18next';

export const handleUploadErrors = ({ data }: UploadError) => {
  if (data.errors)
    return data.errors.map((error) =>
      t('invalid-vehicle-property', { vin: error.vin, prop: t(error.prop) }),
    );

  if (data.duplicates)
    return data.duplicates.map((duplicate) =>
      t(`duplicate-vehicle-property${!data.toDatabase ? '-file' : ''}`, {
        props: Object.keys(duplicate)
          .map((key) => `${t(key)}: ${duplicate[key as keyof DuplicateObject]}`)
          .join('] ['),
      }),
    );
};
